<template>
    <UpTable :hoverable="true" :data='fetchSchoolUsers' :paginated="fetchSchoolUsers.length > 10" :per-page="10">
        <UpTableColumn label="Name" field="name" v-slot="props" sortable>
          {{ props.row.name }}
        </UpTableColumn>
        <UpTableColumn label="Email" field="email" v-slot="props" sortable>
          {{ props.row.email }}
        </UpTableColumn>
        <UpTableColumn label="Mobile" field="mobile" v-slot="props" sortable>
          {{ props.row.mobile }}
        </UpTableColumn>
        <UpTableColumn label="Action" v-slot="props">
          <div class="buttons is-right" style="display:block">
            <button @click="edit(props.row._id)" class="button is-small is-primary"  type="button">
              <b-icon icon="pencil" size="is-small"></b-icon>
            </button>
            <button class="button is-small is-danger" type="button"  @click="delete(props.row._id)">
              <b-icon icon="delete" size="is-small"></b-icon>
            </button>
            <button v-if="type == 'P'" class="button is-small is-danger" type="button"  @click="delete(props.row._id)">
              <b-icon icon="chart-bar" size="is-small"></b-icon>
            </button>
          </div>
        </UpTableColumn>
    </UpTable>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
    name : 'user-table',
	props : {
        type:{
            type:String,
        }
	},
    methods: {
      ...mapActions(['loadSchoolUsers', 'deleteSchoolUser']),
    editSchoolUser(id) {
      this.edit_id = id
      this.modalEditPO = true
    },
    deleteSchoolUser(id) {
      this.$buefy.dialog.confirm({
        message: 'Are you sure?',
        onConfirm: () => {
          this.deleteSchoolUser({ token: this.userToken, id }).then(() => {
            this.$buefy.toast.open({
              message: 'Teacher deleted successfully',
              type: 'is-success'
            })
          }).catch(err => {
            this.$buefy.toast.open({
              message: err.response.data,
              type: 'is-danger'
            })
          })
        }
      })
    },
    },
    computed: {
      ...mapGetters(['fetchSchoolTeachers', 'fetchSchoolStudents', 'getTeacherToken']),
      fetchSchoolUsers(){
        if(this.type=="P")
          return this.fetchSchoolStudents;
        else if(this.type=="ST")
          return this.fetchSchoolTeachers;
        else
          return [];
      }
    },
    created(){
        this.loadSchoolUsers({ token: this.getTeacherToken, type: this.type});
    },
}
</script>
<style scoped>
</style>
